import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React from 'react'

import { IconTime } from '@s4l/icons/IconTime'
import { IconCreditCard } from '@s4l/icons/IconCreditCard'
import { IconPayment } from '@s4l/icons/IconPayment'
import { useS4LContext } from '@s4l/react-context'
import { Advantage } from './Advantage'
import { AdvantageTitle } from './Title'

import styles from './index.module.css'

export const advantages = [
  {
    icon: <IconTime />,
    title: 'usp.title-1',
    subtitle: 'usp.body-1',
  },
  {
    icon: <IconCreditCard />,
    title: 'usp.title-2',
    subtitle: 'usp.body-2',
  },
  {
    icon: <IconPayment />,
    title: 'usp.title-3',
    subtitle: 'usp.body-3',
  },
]

function Advantages() {
  const { i18n } = useS4LContext()

  return (
    <section className={styles.advantages}>
      <div className={styles.content}>
        <header className={styles.header}>
          <AdvantageTitle />
        </header>
        <ul className={styles.advantageList}>
          {advantages.map(advantage => {
            const title = i18n.formatMessage({ id: advantage.title })
            const subtitle = i18n.formatMessage({ id: advantage.subtitle })

            return (
              <li key={title}>
                <Advantage title={title} subtitle={subtitle} icon={advantage.icon} />
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

Advantages.displayName = 'Advantages'
export default withErrorBoundary(Advantages)
